// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28jHP","delete":"styles_delete__2flYN","update":"styles_update__PDPbB","add":"styles_add__2SNM3"};